class StatementsPreferencesEntity {
  constructor() {
    this.accountId = null;
    this.optOutFlag = null;
    this.accountName = null;
    this.sortCode = null;
    this.accountNumber = null;
    this.availableBalance = null;
    this.visibility = null;
    this.display_order = null;
  }
}

export default StatementsPreferencesEntity;
